// How a unit's address reads everywhere in the admin: the block (or street
// name) as the cluster typed it, then the number, e.g. "A2 No. 18" or
// "Matahari No. 5". No "Blok" prefix, since the block isn't always a block.

/** "A2 No. 18"; just "No. 18" for a cluster without blocks. */
export function unitAddress(block: string | null | undefined, number: string | null | undefined): string {
  const b = (block ?? '').trim();
  const n = (number ?? '').trim();
  if (!n) return b;
  return b ? `${b} No. ${n}` : `No. ${n}`;
}

/**
 * Whether a unit's label only repeats its address ("A-12", "A 12", "A No. 12"
 * or just "12"), so it isn't worth showing next to it.
 */
export function labelRepeatsAddress(label: string | null | undefined, block: string, number: string): boolean {
  const l = (label ?? '').trim();
  return !l || [`${block}-${number}`, `${block} ${number}`, unitAddress(block, number), number].includes(l);
}
